import { Loading } from '@livecontrol/core-ui';
import { Panel } from '../../../../components';
import type { ScheduledEvent } from '../../graphql';
import { Iframe } from './iframe';

export const Performance = ({
  scheduledEvent
}: {
  scheduledEvent?: ScheduledEvent;
}): React.ReactElement => {
  if (!scheduledEvent) {
    return <Loading isOldVersion />;
  }

  const muxUrl = scheduledEvent.location?.mux_stream_id ?
  `https://dashboard.mux.com/organizations/g91c68/environments/599vti/video/live-streams/${scheduledEvent.location.mux_stream_id}/monitor`
   : null;

  return (
    <div className='text-white'>
      <h2 className='mt-24px mb-20px'>Performance</h2>

      <div
        className='d-flex flex-column flex-xl-row'
        style={{
          columnGap: 15,
          rowGap: 15
        }}
      >
        {muxUrl ? (
        <div className='w-100 d-flex flex-column'>
          <a href={muxUrl} target="_blank" rel="noopener noreferrer" style={{marginBottom: '12px'}}>
            Open Mux Performance Monitor
          </a>
          <Iframe src={muxUrl} />
        </div>
        ) : (
        <Panel className='mt-8px p-0'>
        <span className='text-white d-flex align-items-center justify-content-center p-16px'>
          The performance could not load
        </span>
      </Panel>
      )}
      </div>
    </div>
  );
};
